import { NgModule } from "@angular/core";
import { WorkflowFormModule } from "../form/workflow-form.module";
import { DamWorkflowRoutingModule } from "./dam-workflow.routing";
import { DamWorkflowListModule } from "./list/dam-workflow-list.module";

@NgModule({
    imports: [DamWorkflowRoutingModule, DamWorkflowListModule, WorkflowFormModule],
})
export class DamWorkflowModule {}
